import Api from 'utils/api'

export const fetchTemplate = ({ project, uuid }: { project?: string | number; uuid: string }) =>
  Api.get(['templates', uuid], { project })
